"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.minimalFeeAmountToCoverFees = exports.CENTS_AMOUNT = exports.isNever = exports.roundNumber = void 0;
const roundNumber = (num, decimals = 2) => Math.round((num + Number.EPSILON) * Math.pow(10, decimals)) / Math.pow(10, decimals);
exports.roundNumber = roundNumber;
// Types util
const isNever = (_foo) => undefined;
exports.isNever = isNever;
exports.CENTS_AMOUNT = 100;
var minimalFeeAmountToCoverFees_1 = require("./minimalFeeAmountToCoverFees");
Object.defineProperty(exports, "minimalFeeAmountToCoverFees", { enumerable: true, get: function () { return minimalFeeAmountToCoverFees_1.minimalFeeAmountToCoverFees; } });
//# sourceMappingURL=index.js.map